// extracted by mini-css-extract-plugin
export var box = "_5i-0";
export var check = "_5i-1";
export var checkboxButton = "_5i-6";
export var checkboxGroup = "_5i-5";
export var disabled = "_5i-7";
export var ghost = "_5i-9";
export var input = "_5i-2";
export var label = "_5i-4";
export var normal = "_5i-8";
export var uncheck = "_5i-3";